const dateKey = (value) => String(value || "").slice(0, 10);

export function groupShiftAssignments(assignments, members, today, query = "", memberFilter = "") {
  const groups = new Map();
  const ensure = (id, member = {}) => {
    const key = String(id);
    if (!groups.has(key)) groups.set(key, {
      id: key,
      name: member.name || member.member_name || `Member #${id}`,
      status: member.status || member.member_status || "unknown",
      current: null,
      conflict: false,
      upcoming: [],
      history: [],
    });
    return groups.get(key);
  };

  members.forEach((member) => ensure(member.id, member));
  assignments.forEach((assignment) => {
    const group = ensure(assignment.business_member_id, {
      name: assignment.member_name,
      status: assignment.member_status,
    });
    const from = dateKey(assignment.effective_from);
    const until = dateKey(assignment.effective_until);
    if (!from || (until && until < from) || (until && until < today)) {
      group.history.push(assignment);
    } else if (from > today) {
      group.upcoming.push(assignment);
    } else if (group.conflict) {
      group.history.push(assignment);
    } else if (group.current) {
      group.conflict = true;
      group.history.push(group.current);
      group.current = null;
      group.history.push(assignment);
    } else {
      group.current = assignment;
    }
  });

  const search = query.trim().toLowerCase();
  return Array.from(groups.values())
    .filter((group) => !memberFilter || group.id === String(memberFilter))
    .filter((group) => !search || [group.name, group.status, group.current?.shift_name,
      ...group.upcoming.map((row) => row.shift_name), ...group.history.map((row) => row.shift_name)]
      .some((value) => String(value || "").toLowerCase().includes(search)))
    .map((group) => ({
      ...group,
      upcoming: group.upcoming.sort((a, b) => dateKey(a.effective_from).localeCompare(dateKey(b.effective_from))),
      history: group.history.sort((a, b) => dateKey(b.effective_from).localeCompare(dateKey(a.effective_from))),
    }))
    .sort((a, b) => a.name.localeCompare(b.name) || a.id.localeCompare(b.id));
}
